export const messageService = {
  add: message => new Promise( resolve => resolve( { data: message } ) ),

  remove: message => new Promise( resolve => resolve( { data: message } ) ),

  post: () => {
    throw 'Not implemented exception'; 
  },

  get: () => {
    throw 'Not implemented exception'; 
  }
};